var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPortal = function SvgPortal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.32 8 11.6v31.33h32V11.6L24 6.32zm2 32.61h-4v-17.5l2-.66 2 .66v17.5zm10 0h-6v-20.4l-6-2-6 2v20.4h-6V14.49l12-4 12 4v24.44z"
  })));
};
export { SvgPortal as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxwYXRoIGQ9Ik0yNCA2LjMyTDggMTEuNnYzMS4zM2gzMlYxMS42TDI0IDYuMzJ6bTIgMzIuNjFoLTR2LTE3LjVsMi0uNjYgMiAuNjZ2MTcuNXptMTAgMGgtNnYtMjAuNGwtNi0yLTYgMnYyMC40aC02VjE0LjQ5bDEyLTQgMTIgNHYyNC40NHoiLz4KPC9zdmc+Cg==";